var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEclipseTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 128,
    viewBox: "0 0 222 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 17,
    r: 111,
    fill: "url(#paint0_linear_4497_5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4497_5",
    x1: 0,
    y1: 17,
    x2: 222,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A3519F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B489D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipseTop);
export default __webpack_public_path__ + "static/media/eclipse_top.4218fef92c493bd6057f6e3174acb4d0.svg";
export { ForwardRef as ReactComponent };